import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { useDockedContext } from 'Context/DockedContext';

import Typography from 'Components/UI/Typography';

import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import Actions from '../Actions';

const styles = theme => ({
  root: {
    height: theme.spacing(6),
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md,
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0, 2),
    cursor: 'pointer',
    backgroundColor: theme.palette.common.white,
  },
  rootEmbedded: {
    margin: 0,
  },
  title: {
    padding: theme.spacing(0, 1.5),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flex: 1,
    width: 250,
  },
});

function Minimized({
  className,
  classes,
  embedded,
  item,
  ActionsProps,
  ...rest
}) {
  const { getItemTitle } = useDockedContext();
  const { toggleMinimized } = ActionsProps;
  return (
    <Paper
      {...rest}
      aria-hidden
      className={classNames(classes.root, className, {
        [classes.rootEmbedded]: embedded,
      })}
      onClick={() => toggleMinimized('Header')}
      variant={'tight'}
    >
      <Typography
        className={classes.title}
        color="black"
        variant="h5"
      >
        {getItemTitle(item.key)}
      </Typography>
      <Actions {...ActionsProps} />
    </Paper>
  );
}

Minimized.defaultProps = {
  className: '',
  embedded: false,
};

Minimized.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  embedded: PropTypes.bool,
  item: PropTypes.object.isRequired,
  ActionsProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(Minimized);
